import React from "react";
import { Form, Row, Col, InputGroup, FormText } from "react-bootstrap";
import {
  API_ENDPOINTS,
  handleKeyDown,
  TERMSVENDOR,
} from "../../constant/_constant";
import {
  IconFileDollar,
  IconFileInvoice,
  IconId,
  IconWorldPin,
} from "@tabler/icons-react";
import { Controller } from "react-hook-form";
import FileUpload from "../../components/Attachment/Attachment";
import Notes from "../../components/Notes/Notes";

const VendorFormStep3 = ({
  formData,
  handleFormChange,
  control,
  errors,
  isEditing,
  attachmnetid,
}) => {
  return (
 
        <FileUpload
          moduleType={"VENDOR"}
          attachmnetid={attachmnetid}
          maxFiles={20}
          maxFileSize={20}
          onFilesChange={(updatedFiles) => console.log(updatedFiles)}
        />
   
 
  );
};

export default VendorFormStep3;
